import React, { useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerWithTimeComponent from "../DatePickerWithTimeComponent";
import DropDownComponent from "../DropDownComponent";
import { useAuth } from "../../contexts/AuthContext";
import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { showCustomToast } from "../Misc/CustomToast";
import UploaderDocForNote from "../Updloader/UploaderDocForNote";
import InputComponent from "../InputComponent";

import Chip from "@mui/material/Chip";

function AddFamilyNote(props) {
  //VARIABLES
  const { currentUser } = useAuth();

  // useEffect(() => {
  //   recordMetrics("Notes", "familyNotes", currentUser.email, "write", "bodhi");
  // }, []);

  //STATES
  const [isLoading, setIsLoading] = useState(false);
  const [familyNote, setFamilyNote] = useState("");
  const [familyNoteDateTime, setFamilyNoteDateTime] = useState(new Date());
  const [relationshipFamilyNote, setRelationshipFamilyNote] = useState("");
  const [relationshipFamilyNoteOther, setRelationshipFamilyNoteOther] =
    useState("");
  const [files, setFiles] = useState([]);
  const draftKey = `draft:familyNote:${currentUser?.uid || "anon"}:${
    props.clientId || "unknown"
  }`;
  const draftDelay = 800;
  const [isSavingDraft, setIsSavingDraft] = useState(false);

  //FUNCTIONS
  const handleFamilyNoteChange = (event) => {
    setFamilyNote(event.target.value);
  };

  const handleDateTimeChange = (event) => {
    setFamilyNoteDateTime(event);
  };

  const handleRelationshipFamilyNote = (event) => {
    setRelationshipFamilyNote(event);
  };

  const handleRelationshipFamilyNoteOther = (event) => {
    setRelationshipFamilyNoteOther(event);
  };

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files.length <= 10) {
      setFiles(event.target.files);
    } else {
      showCustomToast("You can only upload up to 10 files.", "error");
    }
  };

  useEffect(() => {}, [files]);

  const uploadFilesAndGetUrls = async (docId) => {
    const storage = getStorage();
    const fileUrls = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const filePath = `Documents/familyNotes/${docId}/${file.name}`;
      const storageRef = ref(storage, filePath);

      await uploadBytes(storageRef, file);
      const fileUrl = await getDownloadURL(storageRef);
      fileUrls.push({ url: fileUrl, name: file.name });
    }

    return fileUrls;
  };

  const handleAddFamilyNote = async (
    note,
    clientID,
    effectiveDateTime,
    relationship,
    relationshipOther
  ) => {
    const noteData = {
      noteType: "familyNote",
      noteContent: note,
      clientId: clientID,
      createdAt: serverTimestamp(),
      effectiveDateTime: effectiveDateTime,
      doneBy: currentUser.displayName,
      relationShipFamilyNote: relationship,
      clientFirstName: props.firstName,
      clientLastName: props.lastName,
      clientProfilePicture: props.profilePicture || "",
      relationShipFamilyNoteOther: relationshipOther,
    };

    if (familyNote && familyNoteDateTime && relationshipFamilyNote) {
      setIsLoading(true);
      try {
        const docRef = await addDoc(collection(db, "notes"), noteData);
        const fileUrls = await uploadFilesAndGetUrls(docRef.id);
        await updateDoc(doc(db, "notes", docRef.id), {
          fileUrls: fileUrls,
        });
        showCustomToast(`Non therapy note successfully added!`, "success");

        setIsLoading(false);
        try {
          localStorage.removeItem(draftKey);
        } catch {}
        props.closemodal();
      } catch (error) {
        console.log("error adding note :", error);
        showCustomToast(`Problem when adding note`, "error");
      }
    } else {
      showCustomToast(
        `Some mandatory fields are empty. Please check.`,
        "error"
      );
    }
  };

  const handleSubmit = () => {
    handleAddFamilyNote(
      familyNote,
      props.clientId,
      familyNoteDateTime,
      relationshipFamilyNote,
      relationshipFamilyNoteOther
    );
  };

  // Restore draft on mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(draftKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed?.text) setFamilyNote(parsed.text);
        if (parsed?.date) {
          const d = new Date(parsed.date);
          if (!isNaN(d)) setFamilyNoteDateTime(d);
        }
      }
    } catch (e) {
      console.warn("FamilyNote draft load error:", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Autosave draft with debounce
  useEffect(() => {
    const t = setTimeout(() => {
      try {
        localStorage.setItem(
          draftKey,
          JSON.stringify({
            text: familyNote,
            date: familyNoteDateTime?.toISOString?.() || null,
          })
        );
        setIsSavingDraft(false);
      } catch (e) {
        console.warn("FamilyNote draft save error:", e);
      }
    }, draftDelay);
    setIsSavingDraft(true);
    return () => clearTimeout(t);
  }, [familyNote, familyNoteDateTime, draftKey]);

  return (
    <>
      <div
        // className="inputAndLabelModalContainerTitle2"
        style={{ width: "auto", height: "100%" }}
      >
        <div className="line1-modal-percent">
          <div className="modal-title" style={{ paddingLeft: "10px" }}>
            Add family/significant other note
          </div>
          <CloseIcon
            style={{
              marginRight: "16px",
              color: "rgb(214, 213, 213)",
              cursor: "pointer",
            }}
            onClick={props.closemodal}
          />
        </div>

        <div
          style={{
            width: "100%",
            marginTop: "0px",
            height: "75%",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          <div className="line2-column-modal-bis">
            <div
              className="label-textfield"
              style={{
                paddingLeft: "15px",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              Note content
            </div>
            <TextField
              value={familyNote}
              onChange={handleFamilyNoteChange}
              style={{
                width: "95%",
                borderRadius: "5px",
                backgroundColor: "#f2eeef",
              }}
              placeholder="Type family/significant other note here"
              multiline
              rows={12}
            />
          </div>
          <div
            className="line3-modal-nopad"
            style={{
              // marginLeft: "20px",
              paddingLeft: "30px",
              paddingTop: "10px",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            <DatePickerWithTimeComponent
              value={familyNoteDateTime}
              onChange={handleDateTimeChange}
              title="Effective date and time"
            />

            <DropDownComponent
              api="relationship"
              title="Relationship to client"
              value={relationshipFamilyNote}
              onChange={handleRelationshipFamilyNote}
            />
            {relationshipFamilyNote === "Other" ? (
              <InputComponent
                title="If Other, describe"
                value={relationshipFamilyNoteOther}
                onChange={handleRelationshipFamilyNoteOther}
                style={{
                  width: "95%",
                  borderRadius: "5px",
                  backgroundColor: "#f2eeef",
                }}
                // placeholder="Type family/significant other note here"
              />
            ) : (
              ""
            )}
          </div>

          <UploaderDocForNote
            handleFileChange={handleFileChange}
            files={files}
          />
        </div>
        <div
          className="line4-modal-percent"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >
          <Chip
            label={
              isSavingDraft
                ? "Saving draft..."
                : familyNote
                ? "Draft saved"
                : "No draft"
            }
            size="small"
            sx={{
              backgroundColor: isSavingDraft
                ? "#f9a825"
                : familyNote
                ? "#2e7d32"
                : "#607d8b",
              color: "#fff",
              fontWeight: 700,
            }}
          />
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              try {
                localStorage.removeItem(draftKey);
              } catch {}
              setFamilyNote("");
              setFamilyNoteDateTime(new Date());
            }}
          >
            Clear draft
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: "white", color: "black" }}
            onClick={props.closemodal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={
              isLoading
                ? {
                    backgroundColor: "red",
                    color: "white",
                    marginLeft: "15px",
                  }
                : {
                    backgroundColor: "#1565C0",
                    color: "white",
                    marginLeft: "15px",
                  }
            }
            disabled={isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? "SUBMITTING..." : "SUBMIT"}
          </Button>
        </div>
      </div>
    </>
  );
}

export default AddFamilyNote;
